import React from 'react';
import "./Cv.css";
import { FiDownload, FiFileText } from 'react-icons/fi';
import cv from "../../assets/doc/Stephane_Kikoni_CV.pdf";

const Cv = () => {
    return (
        <section className='cv-section' id="cv">
            <div className='parallax-bg'></div>
            <div className='overlay'></div>

            <div className='cv-content'>
                <div className='download-wrapper'>
                    <div className='tech-lines'>
                        <span></span>
                        <span></span>
                    </div>

                    <a className='cv-download-btn' href={cv} download>
                        <div className='btn-icon'>
                            <FiFileText className='file-icon' />
                            <FiDownload className='dl-icon' />
                        </div>
                        <div className='btn-text'>
                            <span className='main-txt'>Télécharger mon CV</span>
                            <span className='sub-txt'>PDF / 253KB - Dossier Technique</span>
                        </div>
                    </a>

                    <div className='tech-lines bottom'>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Cv;